import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex text-center",
  style: {"height":"20vh"}
}
const _hoisted_2 = { class: "m-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Your Position", -1)
const _hoisted_4 = {
  type: "text",
  ref: "origin",
  id: "address"
}
const _hoisted_5 = {
  ref: "mapDiv",
  id: "mapDiv",
  style: {"width":"100%","height":"80vh"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("input", _hoisted_4, null, 512),
        _createTextVNode(" Latitude: " + _toDisplayString($setup.currPos.lat.toFixed(2)) + ", Longitude: " + _toDisplayString($setup.currPos), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, null, 512)
  ], 64))
}